import { UseCase } from "../../base";
import { ProductActivity } from "../../domain/models";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductActivityRepository } from "../../repositories";

@Injectable({providedIn: 'root'})
export class GetActivitiesByProductUsecase implements UseCase<string, ProductActivity[]> {

  constructor(private repository: ProductActivityRepository) {
  }

  execute(params: string): Observable<ProductActivity[]> {
    return this.repository.getActivitiesByProduct(params);
  }
}
